"use client";
/**
 * Client wrapper for the public /preview sample deck: the real SwipeDeck with
 * a no-op recorder. Nothing is written anywhere — no swipe rows (the visitor
 * has no account), no client-side storage (E-7); the tally lives in memory
 * only to know when the tour is over.
 */
import { useState } from "react";
import Link from "next/link";
import { useTranslations } from "next-intl";
import { SwipeDeck, type SwipeCard } from "../../components/SwipeDeck";

export function PreviewDeck({ cards }: { cards: SwipeCard[] }) {
  const t = useTranslations("preview");
  const [decided, setDecided] = useState(0);

  if (decided >= cards.length) {
    return (
      <section className="deck deck-empty" aria-label={t("sampleDeckAria")}>
        <div className="deck-empty-card">
          <h2>{t("tourOverTitle")}</h2>
          <p>{t("tourOverBody")}</p>
          <p>
            <Link href="/signup" className="button-primary">{t("createAccount")}</Link>
          </p>
        </div>
      </section>
    );
  }

  return (
    <SwipeDeck
      cards={cards}
      onSwipe={async () => {
        setDecided((d) => d + 1);
      }}
    />
  );
}
